import { cx } from "@its-engineering-and-development/ui-foundation/utils";
import type { ReactNode } from "react";

export interface DashboardCardProps {
    title: string;
    action?: ReactNode;
    /** Full-width control rendered below the centered title. */
    filter?: ReactNode;
    children: ReactNode;
    className?: string;
}

/** Stretch summary cards to the tallest card in the dashboard row (usually Spend). */
export const DASHBOARD_SUMMARY_CARD_CLASS = "h-full min-h-0";

/** Shared card shell for dashboard summary sections. */
export function DashboardCard({ title, action, filter, children, className }: DashboardCardProps) {
    return (
        <section className={cx("flex min-h-[320px] flex-col rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5", className)}>
            <div className={cx("mb-4 flex shrink-0 flex-col gap-3", action ? "sm:flex-row sm:items-start sm:justify-between" : "items-center")}>
                <h2 className={cx("text-base font-semibold text-gray-900", !action && "text-center")}>{title}</h2>
                {action ? <div className="shrink-0">{action}</div> : null}
                {filter ? <div className="w-full">{filter}</div> : null}
            </div>
            <div className="flex min-h-0 flex-1 flex-col">{children}</div>
        </section>
    );
}
